import { MAX_PAGINATION_LIMIT } from "shared/constants";

export default {
  pagination(state) {
    return {
      page: state.page[state.searchTab],
      pageSize: state.pageSize[state.searchTab],
      pageCount: Math.ceil(
        Math.min(state.totalContacts, MAX_PAGINATION_LIMIT) /
          state.pageSize[state.searchTab]
      ),
    };
  },
  getFilters({
    keywordQuery,
    keywordOutletFields,
    keywordInfluencerFields,
    filterLocations,
    filterTalkingAboutTags,
    filterTalkingAboutOperator,
    filterTargetAreas,
    filterTopics,
    filterDesignatedMarketAreas,
    filterLanguages,
    filterSocials,
    filterCoverages,
    filterMediaTypes,
    filterCirculation,
    filterFrequencies,
    filterContentTypes,
  }) {
    return {
      keywordQuery: keywordQuery.replace("&", "%26"),
      keywordOutletFields,
      keywordInfluencerFields,
      filterLocations,
      filterTalkingAboutTags,
      filterTalkingAboutOperator,
      filterTargetAreas,
      filterTopics,
      filterDesignatedMarketAreas,
      filterLanguages,
      filterSocials,
      filterCoverages,
      filterMediaTypes,
      filterCirculation,
      filterFrequencies,
      filterContentTypes,
    };
  },
};
